// removed by extract-text-webpack-plugin
module.exports = {"Slideshow":"Slideshow__Slideshow___5aSaF","SlideshowContain":"Slideshow__SlideshowContain___i72Sp","dots":"Slideshow__dots___EdEXM","dotSingle":"Slideshow__dotSingle___26-tC","dotSingleActive":"Slideshow__dotSingleActive___3rsyz"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Slideshow/Slideshow.less
// module id = 1209
// module chunks = 0 1